//import Components
import {Nav, NavItem} from "reactstrap";
import * as lodash from "lodash";
import {NavLink, useNavigate} from "react-router-dom";
import {pageTree} from "../../../context/pageTree";

//node modules
import React, {useRef} from 'react';
import {useConfigStore} from "../../../context/configs";
import shallow from "zustand/shallow";
import {useSettingStore} from "../../../context/settings";
import {useDetectOutSideClick} from "../../../global/callback functions/Triggers/eventListners";
import {AppStateProps, useAppState} from "../../../context/state";


export default function SideNav() {
  const {appState} = useAppState();
  if (!appState?.user) {
    return null;
  }

  return (
    <>
      <span className={"sideNav-heading"}>Meny</span>
      <Nav as={"ul"}>
        {pageTree.map((page, i) => {
          return LinkRender(page, i, appState.user);
        })}
      </Nav>
    </>
  )
}

function LinkRender(route: any, i: number, user: AppStateProps['user']) {
  if (route.displayInSideNav && (route.needAuth === false || (user?.permission ?? 4) <= (route.needAuth ?? 0))) {
    if (route.subPages) {
      return <NavGroup route={route} user={user} key={`group-${route.title}`}/>
    }

    return (
      <NavItem className={"sideNav_item"} key={`${route.page}-${i}`}>
        <NavLink title={route.page} className={"sideNav-item nav-link"} to={route.link}>
          <span className={"nav-icon"}>{route.icon}</span> <span className={"nav-label"}>{route.page}</span>
        </NavLink>
      </NavItem>
    )
  }

  return null;
}

//hooks & functions

//components


//validators
type Props = {
  route: any,
  user: AppStateProps['user'],
};

const NavGroup: React.FC<Props> = ({route, user}) => {
  const {expanded, setExpanded, toggleExpanded} = useConfigStore((state) => ({
    expanded: state.getNavGroup(route.title),
    setExpanded: (value: boolean, log = false) => state.setNavGroup(route.title, value, log),
    toggleExpanded: () => state.setNavGroup(route.title, !lodash.get(state, ["navGroups", route.title]))
  }), shallow);
  const sideNavBarExpanded = useSettingStore((state) => state.navbarExtended);

  const navigate = useNavigate();

  const subPageContainerRef = useRef<HTMLDivElement>(null);
  const toggleRef = useRef<HTMLButtonElement>(null);
  useDetectOutSideClick(subPageContainerRef, toggleRef, () => {
    if (!sideNavBarExpanded && window.innerWidth > 600) {
      setExpanded(false);
    }
  });

  return (
    <div
      onMouseEnter={() => {
        if (!sideNavBarExpanded && window.innerWidth > 600) {
          setExpanded(true);
        }
      }}
      onMouseLeave={() => {
        if (!sideNavBarExpanded && window.innerWidth > 600) {
          setExpanded(false);
        }
      }}
      className={"sideNav_group"}>
      <button
        ref={toggleRef}
        className={"navGroup-title sideNav-item nav-link"}
        title={route.title}
        onClick={() => {
          if (!sideNavBarExpanded && route.mobileRedirect && window.innerWidth < 600) {
            navigate(route.mobileRedirect);
          } else if (!sideNavBarExpanded) {
            toggleExpanded();
          } else {
            toggleExpanded();
          }
        }}
      >
        <span className={"nav-icon"}>{route.icon}</span>&nbsp;
        <span className={"nav-label"}>{route.title}</span>
      </button>

      <div
        onMouseLeave={() => {
          if (!sideNavBarExpanded) {
            setExpanded(false);
          }
        }}
        onBlur={() => {
          if (!sideNavBarExpanded) {
            setExpanded(false);
          }
        }}
        ref={subPageContainerRef}
        className={"subPagesWrapper" + (expanded ? " expanded" : "")}
      >
        <div className={"sideNav_subpages"}>
          {route.subPages.map((page: any, i: number) => LinkRender(page, i, user))}
        </div>
      </div>
    </div>
  );
};

